<template>
  <div>
    <div class="main-content main-content1 font1rem">
      <!-- one tab -->
      <div class="conatiner-fluid d1" id="DataA">
        <div class="row mt-3">

          Hier der TEXT
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../utils/axiosinstance'
// import axios from 'axios'
import {required} from 'vuelidate/lib/validators'
import {todayDate} from '../common'
export default {
  name: 'customers',
  data () {
    return {
      'fromCustomers': 1
    }
  },

  mounted () {
    console.log('customers')
  },

  created () {
    console.log('created')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/customers/index.vue